import instance from '@/api/index.js'
const urlPrefix = '/v1/product'
export default {
  getProducts (params){
    return instance({
      method: 'get',
      params: {
        product_name: params,
      },
      url: `${urlPrefix}/list`,
    })
  },
}
